import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  CareTime_FullTime_getInstance2puuq5c8w5gwp as CareTime_FullTime_getInstance,
  get_entries3dia5qzc4pxls as get_entries,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import {
  CareProgramTemplatemobjbqq2s74k as CareProgramTemplate,
  CareProgramTemplateDated1lvcdu3xhc5up as CareProgramTemplateDated,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { CareProgramTemplatesListPage3j0tqz0uh3p6c as CareProgramTemplatesListPage } from './CareRateTemplatesListPage.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { CareProgramTemplateDetailPagec1d9jyccm55e as CareProgramTemplateDetailPage } from './CareRateTemplateDetailPage.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { nowLocal2mdv5rmil2cf2 as nowLocal } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { LocalDateRangefowoyqa24icz as LocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { _Cents___init__impl__6gjhxu21pac6t02ivb3 as _Cents___init__impl__6gjhxu } from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox,
} from '../components/view-utilities.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name2lx8u3d4hog3p as get_name,
  get_shortNameii4jpwm36hhh as get_shortName,
  get_careTime1h5171nvh773w as get_careTime,
  get_availableAsIntermittent2wvvnkqvc4qfv as get_availableAsIntermittent,
  get_ageStart2z6gzlaamhsp as get_ageStart,
  get_ageEndInclusive1cq80r5bv8q1x as get_ageEndInclusive,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  ageRangeFieldsprqneuhkkp7o as ageRangeFields,
  CareProgramTemplateDatedForm1ksxay8oqics6 as CareProgramTemplateDatedForm,
} from './rateComponents.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, NewCareProgramTemplatePage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, NewCareProgramTemplatePage$actionBar$slambda(element_0));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, NewCareProgramTemplatePage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Add template', VOID, VOID, VOID, VOID, VOID, NewCareProgramTemplatePage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function NewCareProgramTemplatePage$_get_title_$lambda_5rmyze($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateNewTemplatePageTitle_o1z2rc_k$();
}
function NewCareProgramTemplatePage$template$lambda($this$Draft) {
  return new (CareProgramTemplate())(VOID, '', VOID, CareTime_FullTime_getInstance());
}
function NewCareProgramTemplatePage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateNewTemplateHeading_sdjtlb_k$();
}
function NewCareProgramTemplatePage$render$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTemplateNameHeading_spoi4s_k$();
}
function NewCareProgramTemplatePage$render$lambda_1($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateNameLabel_kv7vnk_k$();
}
function NewCareProgramTemplatePage$render$lambda_2($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateShortNameLabel_odyqae_k$();
}
function NewCareProgramTemplatePage$render$lambda_3($this$selectField) {
  return $this$selectField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCareTimeLabel_lijrzh_k$();
}
function NewCareProgramTemplatePage$render$lambda_4(it) {
  return it.displayName_1;
}
function NewCareProgramTemplatePage$render$lambda_5($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateAvailableAsIntermittentLabel_h1v0mn_k$();
}
function NewCareProgramTemplatePage$render$lambda_6($this$CareProgramTemplateDatedForm) {
  return $this$CareProgramTemplateDatedForm.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateFirstVersionFormHeading_9520p9_k$();
}
function NewCareProgramTemplatePage$render$lambda_7($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function NewCareProgramTemplatePage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function NewCareProgramTemplatePage$actionBar$slambda($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (CareProgramTemplatesListPage())());
    return Unit_instance;
  }), 0);
}
function NewCareProgramTemplatePage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateAddTemplateSubmitButton_psnajo_k$();
}
function NewCareProgramTemplatePage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.template_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      tmp_0 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_issues(this$0.version_1);
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !(yield* await_0(this_1, $completion)).isEmpty_y1axqb_k$();
    }
    if (tmp_0) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    var savedTemplate = yield* this$0.template_1.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    yield* (yield* await_0(this_2, $completion)).get_careProgramTemplates_ojj53j_k$().add_co22jy_k$(savedTemplate, $completion);
    var savedVersion = yield* this$0.version_1.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_currentSessionNotNull();
    yield* (yield* await_0(this_3, $completion)).get_careProgramTemplateDateds_knbayp_k$().add_co22jy_k$(savedVersion, $completion);
    var tmp_1 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$6 = yield* await_1(this_4, $completion);
    toast(tmp_1, tmp$ret$6.get_rateTemplateAddedToast_3485d6_k$());
    get_pageNavigator($$this$button.get_context_h02k06_k$()).replace_7qh33u_k$(new (CareProgramTemplateDetailPage())(savedTemplate._id_1));
    return Unit_instance;
  }), 1);
}
var NewCareProgramTemplatePageClass;
function NewCareProgramTemplatePage() {
  if (NewCareProgramTemplatePageClass === VOID) {
    class $ extends Form() {
      constructor() {
        super();
        var tmp = this;
        tmp.template_1 = validated(Draft(NewCareProgramTemplatePage$template$lambda));
        var tmp_0 = this;
        tmp_0.version_1 = validated(Draft(($this$Draft) => new (CareProgramTemplateDated())(VOID, $this$Draft.invoke_r7m7el_k$(this.template_1)._id_1, new (LocalDateRange())(nowLocal().get_date_wokkxj_k$()), _Cents___init__impl__6gjhxu(0n))));
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, NewCareProgramTemplatePage$_get_title_$lambda_5rmyze);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.template_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true) || !(ReactiveState__getOrNull_impl_1asnfp(this.version_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, NewCareProgramTemplatePage$render$lambda);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_2 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_2.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_4, NewCareProgramTemplatePage$render$lambda_0);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        var tmp_5 = NewCareProgramTemplatePage$render$lambda_1;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_3 = this.template_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_6 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$26 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$26);
        var tmp$ret$27 = get_name(it);
        var tmp$ret$24 = lensPath(this_3, tmp$ret$27);
        this.stringField$default_pwglgw_k$(element_2, tmp_5, assertNotBlank(tmp$ret$24), true);
        var tmp_7 = NewCareProgramTemplatePage$render$lambda_2;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_4 = this.template_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_8 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$30 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$30);
        var tmp$ret$31 = get_shortName(it_0);
        var tmp$ret$28 = lensPath(this_4, tmp$ret$31);
        this.stringField$default_pwglgw_k$(element_2, tmp_7, assertNotBlank(tmp$ret$28), true);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_rem(40);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowCollapsingToColumn())(element_2.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
        ensureOutermostElement(element_4);
        element_2.willAddChild_hz2iwc_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_9 = weight(element_4, 1.0);
        var tmp_10 = NewCareProgramTemplatePage$render$lambda_3;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_5 = this.template_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$38 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$38);
        var tmp$ret$39 = get_careTime(it_1);
        var tmp_12 = lensPath(this_5, tmp$ret$39);
        var tmp_13 = _Constant___init__impl__v45mub(get_entries());
        this.selectField_qav2qe_k$(tmp_9, tmp_10, tmp_12, new (Constant())(tmp_13), true, NewCareProgramTemplatePage$render$lambda_4);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_14 = weight(element_4, 1.0);
        var tmp_15 = NewCareProgramTemplatePage$render$lambda_5;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_6 = this.template_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_16 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$43 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$43);
        var tmp$ret$44 = get_availableAsIntermittent(it_2);
        var tmp$ret$41 = lensPath(this_6, tmp$ret$44);
        labeledCheckbox(tmp_14, tmp_15, tmp$ret$41);
        element_4.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_7 = this.template_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_17 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$47 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
        var it_3 = new (DataClassPathSelf())(tmp$ret$47);
        var tmp$ret$48 = get_ageStart(it_3);
        var tmp_18 = lensPath(this_7, tmp$ret$48);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_8 = this.template_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_19 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
        var tmp$ret$51 = isInterface(tmp_19, KSerializer()) ? tmp_19 : THROW_CCE();
        var it_4 = new (DataClassPathSelf())(tmp$ret$51);
        var tmp$ret$52 = get_ageEndInclusive(it_4);
        var tmp$ret$49 = lensPath(this_8, tmp$ret$52);
        ageRangeFields(element_2, tmp_18, tmp$ret$49);
        element_2.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp_20 = themed(element, CardSemantic_getInstance());
        CareProgramTemplateDatedForm(this, tmp_20, this.version_1, NewCareProgramTemplatePage$render$lambda_6);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_9 = shownWhen(element, VOID, VOID, NewCareProgramTemplatePage$render$lambda_7);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Space())(this_9.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_6);
        this_9.willAddChild_hz2iwc_k$(element_6);
        element_6.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_6);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'NewCareProgramTemplatePage', NewCareProgramTemplatePage, VOID, [Page(), CanBlockBack()]);
    NewCareProgramTemplatePageClass = $;
  }
  return NewCareProgramTemplatePageClass;
}
//region block: exports
export {
  NewCareProgramTemplatePage as NewCareProgramTemplatePage9f7vghfhsbym,
};
//endregion

//# sourceMappingURL=NewCareRateTemplatePage.mjs.map
